__turbopack_context__.v({
  "icon": "AudioButton-module__EJqURq__icon",
  "label": "AudioButton-module__EJqURq__label",
  "root": "AudioButton-module__EJqURq__root",
  "speaker-wave-pulse-inner": "AudioButton-module__EJqURq__speaker-wave-pulse-inner",
  "speaker-wave-pulse-outer": "AudioButton-module__EJqURq__speaker-wave-pulse-outer",
});
